(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function unique(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function productSort(a, b) {
    var order = ['T-shirt', 'Hoodie', 'Sticker', 'Mug', 'Poster'];
    return (order.indexOf(a.type) - order.indexOf(b.type)) || a.title.localeCompare(b.title);
  }

  function init(root) {
    var index = window.ARTLINES_VEHICLE_FINDER_INDEX;
    if (!index || !Array.isArray(index.vehicles)) return;

    var vehicles = index.vehicles;
    var makeSelect = root.querySelector('[data-vf-make]');
    var modelSelect = root.querySelector('[data-vf-model]');
    var generationSelect = root.querySelector('[data-vf-generation]');
    var resetButton = root.querySelector('[data-vf-reset]');
    var status = root.querySelector('[data-vf-status]');
    var results = root.querySelector('[data-vf-results]');
    var typeFilters = root.querySelector('[data-vf-type-filters]');
    var selectedType = '';
    var currentMatches = [];

    function setOptions(select, values, placeholder) {
      select.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.appendChild(first);
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    }

    function formatCount(count, noun) {
      return count + ' ' + noun + (count === 1 ? '' : 's');
    }

    function populateMakes() {
      var preferred = ['BMW', 'Porsche', 'Toyota', 'Ford', 'Chevrolet', 'Audi', 'Mercedes-Benz', 'Nissan', 'Honda', 'Subaru'];
      var all = unique(vehicles.map(function (vehicle) { return vehicle.make; }));
      var sorted = preferred.filter(function (make) { return all.indexOf(make) !== -1; })
        .concat(all.filter(function (make) { return preferred.indexOf(make) === -1; }));
      setOptions(makeSelect, sorted, 'Choose a make');
    }

    function filteredVehicles() {
      var make = makeSelect.value;
      var model = modelSelect.value;
      var generation = generationSelect.value;
      return vehicles.filter(function (vehicle) {
        if (make && vehicle.make !== make) return false;
        if (model && vehicle.modelFamily !== model) return false;
        if (generation && [vehicle.generation, vehicle.variant, [vehicle.generation, vehicle.variant].filter(Boolean).join(' / ')].indexOf(generation) === -1) return false;
        return true;
      });
    }

    function updateModels() {
      var make = makeSelect.value;
      selectedType = '';
      results.innerHTML = '';
      typeFilters.hidden = true;
      if (!make) {
        setOptions(modelSelect, [], 'Choose a model');
        setOptions(generationSelect, [], 'All generations');
        modelSelect.disabled = true;
        generationSelect.disabled = true;
        status.textContent = 'Choose a make to start.';
        return;
      }

      var matches = vehicles.filter(function (vehicle) { return vehicle.make === make; });
      setOptions(modelSelect, unique(matches.map(function (vehicle) { return vehicle.modelFamily; })), 'All models');
      modelSelect.disabled = false;
      generationSelect.disabled = true;
      setOptions(generationSelect, [], 'All generations');
      if (matches.length <= 12) {
        renderResults(matches);
      } else {
        status.textContent = 'Choose a model to narrow ' + make + ' results.';
      }
    }

    function updateGenerations() {
      selectedType = '';
      results.innerHTML = '';
      typeFilters.hidden = true;
      var matches = filteredVehicles();
      var generationLabels = unique(matches.map(function (vehicle) {
        return [vehicle.generation, vehicle.variant].filter(Boolean).join(' / ');
      }));
      setOptions(generationSelect, generationLabels, 'All generations');
      generationSelect.disabled = !makeSelect.value || !modelSelect.value || generationLabels.length === 0;
      if (matches.length) {
        renderResults(matches);
      } else {
        status.textContent = 'No matching vehicles found.';
      }
    }

    function renderTypeFilters(products) {
      var types = unique(products.map(function (product) { return product.type; }));
      if (!types.length) {
        typeFilters.hidden = true;
        typeFilters.innerHTML = '';
        return;
      }
      typeFilters.hidden = false;
      typeFilters.innerHTML = '';
      var allButton = document.createElement('button');
      allButton.type = 'button';
      allButton.textContent = 'All products';
      allButton.setAttribute('aria-pressed', selectedType ? 'false' : 'true');
      allButton.addEventListener('click', function () {
        selectedType = '';
        renderResults(currentMatches);
      });
      typeFilters.appendChild(allButton);
      types.forEach(function (type) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = type;
        button.setAttribute('aria-pressed', selectedType === type ? 'true' : 'false');
        button.addEventListener('click', function () {
          selectedType = selectedType === type ? '' : type;
          renderResults(currentMatches);
        });
        typeFilters.appendChild(button);
      });
    }

    function productCard(product) {
      var link = document.createElement('a');
      link.className = 'vehicle-finder__product';
      link.href = product.url;
      var price = product.price ? '$' + Number(product.price).toFixed(2) : '';
      var hoverImage = product.hoverImage && product.hoverImage !== product.image ? product.hoverImage : '';
      link.innerHTML =
        '<div class="vehicle-finder__image-wrap">' +
          (product.image ? '<img class="vehicle-finder__image vehicle-finder__image--primary" src="' + product.image + '&width=360" alt="" loading="lazy">' : '') +
          (hoverImage ? '<img class="vehicle-finder__image vehicle-finder__image--hover" src="' + hoverImage + '&width=360" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="vehicle-finder__product-title">' + product.title + '</div>' +
        '<div class="vehicle-finder__product-meta">' + [product.type, price].filter(Boolean).join(' · ') + '</div>';
      return link;
    }

    function renderResults(matches) {
      currentMatches = matches;
      results.innerHTML = '';
      var allProducts = matches.reduce(function (items, vehicle) {
        return items.concat(vehicle.products);
      }, []);
      renderTypeFilters(allProducts);

      var visibleGroups = matches.map(function (vehicle) {
        return {
          vehicle: vehicle,
          products: vehicle.products.filter(function (product) {
            return !selectedType || product.type === selectedType;
          }).sort(productSort)
        };
      }).filter(function (group) {
        return group.products.length > 0;
      });

      var productCount = visibleGroups.reduce(function (count, group) {
        return count + group.products.length;
      }, 0);
      status.textContent = productCount
        ? 'Showing ' + formatCount(productCount, 'product') + ' across ' + formatCount(visibleGroups.length, 'vehicle group') + '.'
        : 'No products match that product type.';

      visibleGroups.slice(0, 60).forEach(function (group) {
        var section = document.createElement('article');
        section.className = 'vehicle-finder__group';
        var header = document.createElement('div');
        header.className = 'vehicle-finder__group-header';
        header.innerHTML = '<h3 class="vehicle-finder__group-title">' + group.vehicle.label + '</h3><span class="vehicle-finder__group-count">' + formatCount(group.products.length, 'product') + '</span>';
        var grid = document.createElement('div');
        grid.className = 'vehicle-finder__products';
        group.products.forEach(function (product) {
          grid.appendChild(productCard(product));
        });
        section.appendChild(header);
        section.appendChild(grid);
        results.appendChild(section);
      });
    }

    makeSelect.addEventListener('change', updateModels);
    modelSelect.addEventListener('change', updateGenerations);
    generationSelect.addEventListener('change', function () {
      selectedType = '';
      renderResults(filteredVehicles());
    });
    resetButton.addEventListener('click', function () {
      makeSelect.value = '';
      updateModels();
    });
    root.querySelectorAll('[data-vf-quick]').forEach(function (button) {
      button.addEventListener('click', function () {
        var parts = button.getAttribute('data-vf-quick').split('|');
        makeSelect.value = parts[0] || '';
        updateModels();
        modelSelect.value = parts[1] || '';
        updateGenerations();
        renderResults(filteredVehicles());
      });
    });

    populateMakes();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vehicle-finder]').forEach(init);
  });
})();
